/**
 * react-helmet only accepts a plain string (or array of strings) inside <title>.
 * This helper prevents runtime crashes when title is undefined, a number, JSX, etc.
 */
export function normalizeHelmetTitle(value, fallback = 'KolayDoy') {
    if (value == null || value === '') {
        return fallback;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    if (Array.isArray(value)) {
        const parts = value
            .filter((part) => part != null && part !== '')
            .map((part) =>
                typeof part === 'string' || typeof part === 'number' || typeof part === 'boolean'
                    ? String(part)
                    : ''
            )
            .filter(Boolean);
        return parts.length ? parts.join('') : fallback;
    }
    return fallback;
}

export function buildHelmetTitle(appName, pageTitle, { loader = false } = {}) {
    if (loader) {
        return normalizeHelmetTitle(pageTitle);
    }
    const app = normalizeHelmetTitle(appName, '');
    const page = normalizeHelmetTitle(pageTitle, '');
    if (app && page) {
        return `${app} - ${page}`;
    }
    return app || page || 'KolayDoy';
}
